import { render, staticRenderFns } from "./ResetPasscode.vue?vue&type=template&id=05b6db1f&scoped=true"
import script from "./ResetPasscode.vue?vue&type=script&lang=js"
export * from "./ResetPasscode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6db1f",
  null
  
)

export default component.exports